// frontend/src/components/grid/ProductGroupCells.jsx
// The product tree column's cells on a grouped grid (productGrouping.jsx).

import { useTranslation } from 'react-i18next';
import { PRODUCT_GROUP_FIELD, PRODUCT_TITLE_FIELD, PRODUCT_IMAGE_FIELD } from './productFields';
import ProductIdentity from './ProductIdentityView';

// What the product tree column draws on a product row, inside AG Grid's group
// cell between the chevron and the count: the product's featured image and
// title. The bucket of items without a product is not a product, so it has no
// picture and shows its name alone. AG Grid runs this on the variant rows under
// a product too, where the tree column stays empty: their identity is the
// Variant column (`variantProductColumn`), without a picture, so each
// product's is drawn once.
export const ProductGroupCell = ({ data, node }) => {
  const { t } = useTranslation();
  if (!node.group) return null;
  if (data[PRODUCT_GROUP_FIELD] == null) return <span>{t('inventory.ungrouped')}</span>;
  return (
    <ProductIdentity
      imageUrl={data[PRODUCT_IMAGE_FIELD]}
      name={data[PRODUCT_TITLE_FIELD]}
      showSku={false}
    />
  );
};

// The product tree column's cell on the pinned totals row: the row's label as
// plain text. AG Grid's group cell renderer draws every other row of the
// column; a pinned row is not a group and has no key for it to show, so the
// label would otherwise land in the first variant-row column, one cell to the
// right of where the flat view puts it.
export const PinnedGroupLabel = ({ data }) => <span>{data[PRODUCT_GROUP_FIELD]}</span>;
